$(function() {
    var $notificacaoCookies = $('#notificacao-uso-cookies');
    if ($notificacaoCookies.size() > 0) {
        var nomeCookie = 'cookies-aceitos';
        if (!$.cookie(nomeCookie) || $.cookie(nomeCookie) != '1') {
            $notificacaoCookies.addClass('aberto');
            $notificacaoCookies.find('#aceitar-uso-cookies').on('click', function(ev) {
                ev.preventDefault();
                $.cookie(nomeCookie, '1', { expires: 10000, path: window.root_path + '/' });
                $notificacaoCookies.removeClass('aberto');
                return false;
            });
        }
    }
});